import Grid from '../components/grid'
import Container from '../components/ui/container'
import Text from '../components/ui/text'
import { cn } from '../lib/utils'
import { Asset } from '../v2/components/Asset'
import { RichText } from '../v2/components/RichText'
import Divider from './Divider'
import { Page, Asset as AssetT, Asset as AssetType } from '@telesoft/types/payload-types'
import React from 'react'

export type ContentBlockTwoBlockProps = Extract<
  Page['blocks'][0],
  { blockType: 'content-block-two' }
>

export default function ContentBlockTwo(block: ContentBlockTwoBlockProps) {
  const { title, subTitle, description, bulletPoints, image, options } = block
  const lines = options?.lines

  return (
    <Container>
      <Divider />
      <Grid>
        <div className="col-span-full flex flex-col justify-start">
          {subTitle && <h5 className="font-terminal text-telesoft">{subTitle}</h5>}
          <Text className="mb-4" variant="pageHeading">
            {title}
          </Text>
          <Text className="mb-4 max-w-xl" variant="body">
            <RichText content={description} />
          </Text>
        </div>
        <div className="relative col-span-full lg:col-span-6 min-h-[240px] lg:min-h-[400px]">
          {lines && (
            <>
              <div className="invisible lg:visible absolute inset-0 top-10 -left-10 -bottom-10 right-10 border border-black" />
              <div className="invisible lg:visible absolute inset-0 top-4 -left-4 -bottom-4 right-4 bg-white" />
            </>
          )}
          <Asset
            resource={image as AssetT}
            imgClassName={cn(`object-cover object-center`, {
              'bg-contain': options?.containImage ?? false,
            })}
            fill
          />
        </div>
        <div className="col-span-full lg:col-span-6 flex flex-col justify-start items-end">
          <div className="flex flex-col justify-start items-start">
            <div className="mt-8 grid grid-cols-1 gap-4 gap-y-8">
              {bulletPoints &&
                bulletPoints.map((item, i: number) => {
                  const includeSubtitle = item?.includeSubtitle ?? false
                  return (
                    <ListItem
                      key={`item--map--${item.id}-${i}`}
                      title={item.title}
                      isSubtitle={includeSubtitle}
                      subTitle={item?.subTitle}
                      image={item.image as AssetType}
                    >
                      {item.description}
                    </ListItem>
                  )
                })}
            </div>
          </div>
        </div>
      </Grid>
      <Divider />
    </Container>
  )
}

function ListItem({
  children,
  title,
  isSubtitle,
  subTitle,
  image,
}: {
  children: React.ReactNode
  title: string
  isSubtitle: boolean
  subTitle: string | undefined
  image: AssetT
}) {
  return (
    <div className="col-span-1 flex justify-start items-start">
      <div className="w-12 h-12 mt-1.5 mr-4 flex text-telesoft text-xl justify-center items-center border-b border-black border-t">
        <div className="relative w-6 h-6">
          <Asset resource={image} width={24} height={24} />
        </div>
      </div>
      <div className="flex flex-col items-start">
        {isSubtitle && <h5 className="font-terminal text-telesoft">{subTitle}</h5>}
        <Text variant="heading" className="font-medium text-black">
          {title}
        </Text>
        <Text className="font-medium max-w-lg">{children}</Text>
      </div>
    </div>
  )
}
